$(document).ready(function(){
  if($(".purchase-details").length > 0) {
    $(".purchase-details").before("<a class='warning-message' target='_blank' href='https://www.p65warnings.ca.gov/'><img src='https://cdn.shopify.com/s/files/1/1654/6527/files/warning_icon_38314d7f-d86f-4b97-8638-f9a0e465f3d4.svg?v=1705585464' /> Prop 65 Warning</a>")
  }

  $(window).resize(function(){
     if( $(window).width() < 992 ) {
       $(".header-section .nav .toggle_menu > li.sub-menu > ul").show();
     } 
  });
  
  if( $(window).width() < 992 ) {
     $(".header-section .nav .toggle_menu > li.sub-menu > ul").show();
   } 
  
  $(document).on("click", ".search_button", function(e){
    e.preventDefault();
    console.log($(this));
    $(".search_nav").toggleClass("show");
  });

//   $(document).on("click", ".navicon_button", function(){
//     $(this).find(".icon-menu").toggleClass("active");
//   });

  $("body.product .header-section").after($("body.product .container .breadcrumb-section"));
  $("body.collection .header-section").after($("body.collection .container .breadcrumb-section"));
  $(".header .sixteen.columns .twelve .mobile_menu_container .main.menu .sub-sub-menu .li-heading").prev().remove();
  $(".header-section .nav .toggle_menu li li .li-heading").prev().remove();
  $(document).on("click", ".header-section .nav .toggle_menu li ul > li.sub-menu > a", function(e){
    e.preventDefault();
    e.stopPropagation();
    let tabID = $(this).parent().attr("data-id");
    console.log(tabID);
    $(this).closest(".toggle_menu").find($("li")).hide();
    $(this).parent().parent().parent().show();
    $(this).parent().parent().parent().find("> a").hide();
    if($(".back_button").length == 0) {
      $(this).parent().parent().parent().prepend($('<strong class="back_button">BACK</strong>'));
    }
    $(this).parent().show();
    $(this).parent().addClass("active");
    $("#"+tabID).show();
    $("#"+tabID).find("li").show();
    // $(this).find("> span").trigger("click");
  });

  $(document).on("click", "span.li-heading", function(e){
    e.preventDefault();
  });

  $(document).on("click", ".back_button", function() {
    $(this).parent().find("ul li").removeClass("active");
    $(this).next().show();
    $(this).parent().find("ul li ul").hide();
    $(this).closest(".toggle_menu").find("> li").show();
    $(this).closest(".toggle_menu").find("> li > ul > li").show();
    $(this).remove();
  });

  $(".blog-v2 .homepage_content .article").hide();
  $(".blog-v2 .homepage_content .article").slice(0, 6).show();
  if ($(".blog-v2 .homepage_content .article:hidden").length != 0) {
    $("#loadMore").show();
  }   
  $("#loadMore").on('click', function (e) {
    e.preventDefault();
    $(".blog-v2 .homepage_content .article:hidden").slice(0, 3).slideDown();
    if ($(".blog-v2 .homepage_content .article:hidden").length == 0) {
      $("#loadMore").fadeOut('slow');
    }
  });
});